import { Pipe, PipeTransform } from '@angular/core';

export function possessive(noun: string | null | undefined): string {
  if (!noun) {
    return '';
  }

  const cleaned = noun.trim();
  const lastChar = cleaned.slice(-1);

  if (lastChar === '') {
    return '';
  }

  return lastChar === 's' ? `${cleaned}'` : `${cleaned}'s`;
}
@Pipe({
  name: 'possessive',
  standalone: true,
})
export class PossessivePipe implements PipeTransform {
  transform(noun: string | null | undefined): string {
    if (!noun) {
      return '';
    }

    const cleaned = noun.trim();
    const lastChar = cleaned.slice(-1);

    if (lastChar === '') {
      return '';
    }

    return lastChar === 's' ? `${cleaned}'` : `${cleaned}'s`;
  }
}
